import { LabradorComponent } from '@/types/component';
import { placementIdToPlaylistId } from 'base/components/VideoReels/constants';
import { VideoReels } from '@/components/VideoReels';

export const LabradorVideoReels: LabradorComponent = ({ data }) => {
  const { placementID: placementData } = data ?? {};

  if (!placementData) {
    return null;
  }

  const [reelID, title = ''] = placementData.split('%%');

  const placementId = reelID?.trim();
  const playlistId = placementIdToPlaylistId[placementId as keyof typeof placementIdToPlaylistId];

  if (!playlistId) {
    return null;
  }

  return <VideoReels playlistId={playlistId} title={title.trim()} />;
};
